<template>
  <div class="detect-mobile">
    <div v-if="!err_msg" class="spinner-border text-success" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p v-if="err_msg" class="error">{{err_msg}}</p>
  </div>
</template>

<script>
import UserService, {ValidateError}from "@/Services/UserService";

export default {
  name: "DetectMobile",

  mounted() {
    this.search();
  },
  data(){
    return {
      err_msg:'',
    }
  },

  methods: {
    toMsisdn(phoneNumber) {
      // 移除所有非数字字符
      let result = phoneNumber.replace(/\D/g, '');

      // 如果第一个字符是“0”，则移除它。
      if (['0', '+'].includes(result.charAt(0))) {
        result = result.slice(1);
      }

      return result;
    },
    search() {
      const mobile = this.$route.params.mobile || "";
      if (mobile) {
        (new UserService()).users({
          search: mobile
        })
        .then((contacts) => {
          if (contacts.length > 0) {
            return Promise.resolve(contacts[0]?.uid);
          }
          let msisdn = this.toMsisdn(mobile);
          if (msisdn.length == 11) {
            msisdn = `86${msisdn}`;
          }
          if (msisdn.length == 8) {
            msisdn = `852${msisdn}`;
          }
          if(this.checkPhoneNumber(msisdn)){
            return (new UserService()).addUser(`+${msisdn}`, msisdn)
              .then((contact) => {
                if (contacts.length > 0) {
                    return Promise.resolve(contact.uid);
                  }else{
                    return Promise.reject();
                }
              })
          }else{
            this.err_msg = "The given mobile number was invalid."
          }
        })
        .then((uid) => {
          if (uid) {
            this.$router.push({ name: "message", params: { uid } });
          }
        })
        .catch((error)=>{
          if (error instanceof ValidateError) {
              const msgs = error.getValidate();
              this.err_msg = msgs.channel_id || error.message;
            }
        })
      }
    },
    checkPhoneNumber(mobile) {
      const hkRegex = /^\852[6-9]\d{7}$/;
      const mainlandRegex = /^\861[0-9]\d{9}$/;
      if (hkRegex.test(mobile) || mainlandRegex.test(mobile)) {
        return true;
      } else {
        return false;
      }
    },
  }
}
</script>
<style lang="scss">
.detect-mobile {
  height: 100%;
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error{
  color: red;
}
</style>
